import { cn } from "../cn.ts";

export interface EmptyStateProps {
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

export function EmptyState({ title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-3 rounded-2xl border border-dashed border-[var(--brand-border)] bg-[var(--brand-pink-soft)]/50 px-6 py-12 text-center",
        className,
      )}
    >
      <p className="font-heading text-lg font-semibold text-[var(--brand-ink)]">{title}</p>
      {description ? (
        <p className="max-w-sm text-sm text-[var(--brand-muted)]">{description}</p>
      ) : null}
      {action}
    </div>
  );
}
